module.exports = __webpack_public_path__ + "media/images/front/thumb2-1ad037c3c4341fd8ad8a56b685e65505.jpg";